import './styles.css';
import { createGame } from './game';
import { installLifecycle } from './lifecycle';
import { runOnboardingIfNeeded } from './ui/onboarding';
import { initCloud } from './state/cloud';

// First launch on a device captures the owner's details (kept on-device) before the game boots.
void runOnboardingIfNeeded().then(() => {
  const game = createGame();
  installLifecycle(game);
  initCloud(); // offline-first encrypted cloud sync (no-op until online)
  if (new URLSearchParams(location.search).get('e2e') === '1') {
    void import('./testhook').then((m) => m.attachTestHook(game)); // Playwright bridge
  }
});
